import {httpClient} from './httpClient';

const END_POINT = '/category_rules/';

const getAllCategoryRules = (params = {}) => httpClient.get(END_POINT, { params });

const deleteCategoryRule = (category_rule_id) => httpClient.delete(END_POINT + category_rule_id + "/");

const updateCategoryRule = (category_rule_id, body) => httpClient.patch(END_POINT + category_rule_id + "/", body);

export {
    getAllCategoryRules, deleteCategoryRule, updateCategoryRule
}
